import React, { useState } from "react";
const AddNewOffer = () => {
    return (
        <>
        </>
  );
};
export default AddNewOffer;